
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { Action, Getter } from 's-vuex-class'
import { format, subMonths } from 'date-fns'
import Dropdown from './Dropdown.vue'
import BaseButton from './BaseButton.vue'
import DateRangeInput from './DateRangeInput.vue'
import FilterModalMobileHeader from '@/components/FilterModalMobileHeader.vue'
import { isGreyOut } from '@/utils/time'
import { DateTime } from 'luxon'

const DATE_FORMAT = 'DD-MM-YYYY'

@Component<FilterBarTime>({
    components: {
        FilterModalMobileHeader,
        Dropdown,
        BaseButton,
        DateRangeInput,
    },
})
export default class FilterBarTime extends Vue {
    @Getter public $companyVars
    @Getter public filterTimeLabel
    @Getter public filterTimeOptions
    @Getter public filterActive
    @Getter public filterPatching
    @Getter public tsMobileView
    @Getter
    hasNetworkConnection!: boolean

    @Action public setFilterTime
    @Action public populateTimeOptions

    public label = ''
    public from = ''
    public to = ''
    public startOpen = false
    public showDateInput = false

    public getOptionSetClass(indexSet) {
        let classes = 'option-set'
        if (this.tsMobileView) {
            classes += !indexSet ? ' first-option-set' : ''
        } else {
            classes += ' column-1-3'
        }

        return classes
    }

    public getIsGreyOption(indexSet, index) {
        return isGreyOut(
            false, // WEB-7536 - don't grey-out for now
            this.$companyVars.created,
            Number(indexSet),
            Number(index)
        )
    }

    @Watch('filterTimeLabel')
    public watchFilterTimeLabel() {
        if (this.filterTimeLabel.label === 'custom') {
            this.showDateInput = true
            this.copyFromStore()
        } else {
            this.showDateInput = false
        }
    }

    public get displayDate() {
        return {
            from: this.parseDate(this.from),
            to: this.parseDate(this.to),
        }
    }

    public mounted() {
        this.populateTimeOptions()
        this.copyFromStore()
    }

    public copyFromStore() {
        const { label, from, to } = this.filterTimeLabel
        this.label = label
        this.from = from || ''
        this.to = to || ''
        if (this.tsMobileView) {
            this.showDateInput = false
        }
    }

    public parseDate(date: string): Date {
        const [DD, MM, YYYY] = date.split('-').map((n) => parseInt(n, 10))

        const timeZone = this.$companyVars.timezone || DateTime.local().zoneName

        const luxonDate = DateTime.fromObject({
            day: DD,
            month: MM,
            year: YYYY,
            zone: timeZone,
        })

        return luxonDate.toJSDate()
    }

    public async setDateRange({ from, to }) {
        if (this.setFilterTime) {
            await this.setFilterTime({
                id: this.filterActive.id,
                time_unit: 'custom',
                time_value: `${format(from, 'DD-MM-YYYY')}_${format(
                    to,
                    'DD-MM-YYYY'
                )}`,
            })
        }
    }

    public async setTimeOption(option, indexSet, index) {
        if (this.getIsGreyOption(indexSet, index)) {
            return
        }

        if (option.time_unit === 'custom') {
            this.startOpen = true
            this.label = 'custom'
            this.from = format(subMonths(new Date(), 1), DATE_FORMAT)
            this.to = format(new Date(), DATE_FORMAT)
            this.showDateInput = true
        } else if (this.filterActive) {
            await this.setFilterTime({
                id: this.filterActive.id,
                time_unit: option.time_unit,
                time_value: option.time_value,
            })
            this.startOpen = false
        }
        const dropdown = this.$refs.dropdown as any
        if (dropdown) {
            dropdown.$data.opened = false
        }
    }

    public formatDates() {
        return this.from + ' - ' + this.to
    }

    private closeModal() {
        (this.$refs.dropdown as any).$data.opened = false
    }

    public get theFilterTimeLabel() {
        if (this.filterTimeLabel?.label) {
            return this.filterTimeLabel.label
        }

        return ''
    }
}
